const noop = () => null;

export default noop;
